import { Injectable } from '@angular/core';
import { Store } from '../store';

@Injectable()
export class BalloonPopupService extends Store<HTMLElement> {
  constructor() {
    super(null);
  }

  public setAttachedElement(element: HTMLElement): void {
    this.setState(element);
  }

  public removeAttachedElement(): void {
    this.setState(null);
  }
}


// WEBPACK FOOTER //
// ./ts/app/shared/balloon-popup/balloon-popup.service.ts